export interface CustomerEleringAuthorization {
  customerEic: string;
  authorizations : {
    meteringPointEic: string;
    authorized: boolean;
  }[]
}

export interface CustomerNavirecAccount {
  id: string;
  url: string;
  name: string;
  reference?: number;
  vatNumber?: string;
  registryCode?: string;
}

export enum CustomerRole {
    WEB_ADMIN,
    WEB_ACCESS,
    REPRESENTATIVE
}

export const CustomerRoleTranslations: Record<CustomerRole, string> = {
    [CustomerRole.WEB_ACCESS]: 'Tavakasutaja',
    [CustomerRole.WEB_ADMIN]: 'Peakasutaja',
    [CustomerRole.REPRESENTATIVE]: 'Esindaja',
};

export const CUSTOMER_ROLE_OPTIONS = [
    {
        label: CustomerRoleTranslations[CustomerRole.WEB_ACCESS],
        value: CustomerRole.WEB_ACCESS,
    },
    {
        label: CustomerRoleTranslations[CustomerRole.WEB_ADMIN],
        value: CustomerRole.WEB_ADMIN,
    }
];

